<template>
  <div class="content">
    <b-breadcrumb>
      <b-breadcrumb-item :to="{ path: '/dashboard' }">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Información Constitución de Sociedades</b-breadcrumb-item>
    </b-breadcrumb>

    <router-link :to="{ name: 'AddConstitucion' }" custom>
      <b-button class="btn-fill orange-btn bottom1" custom>Iniciar proceso</b-button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "ConstitucionSociedadesInfo",
};
</script>
